import styled, { css, keyframes } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const FeedbackImage = styled.img`
  margin-right: ${layout.measurements.spacing100};
  height: 72px;
  width: 72px;
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ScaleWrapper = styled.div`
  margin-top: 17px;
  width: 260px;

  ${media.smallOnly`
      width: 275px;
    `};
`;

export const QuestionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${layout.measurements.spacing100};

  > h4 {
    flex-grow: 0;
    text-align: center;
  }
`;

export const Question = styled.div<{ $fade?: boolean }>`
  ${p =>
    p.$fade
      ? css`
          animation: ${fadeOut} 250ms ease-in-out 1;
        `
      : css`
          animation: ${fadeIn} 150ms ease-in-out 1;
        `}
  animation-fill-mode: forwards;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  h4 {
    display: inline;
    flex-grow: 0;
    text-align: center;

    &:first-of-type {
      margin-right: 6px;
    }

    ${media.smallOnly`
      margin-right: 0;
      margin-bottom: 0;
      display: block;
    `};
  }
`;

export const SurveyLink = styled.a`
  color: ${p => p.theme.text.callToAction};
`;

export const Close = styled.div`
  cursor: pointer;
  position: absolute;
  top: ${layout.measurements.spacing100};
  right: ${layout.measurements.spacing100};
`;
